<template>
    <div class="justificacion-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="450">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">Montos de Solicitudes de pago</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid grid-list-xl>
                                <v-layout align-center wrap>
                                    <v-flex tag="strong" sm6 text-xs-right mr-2>Monto total:</v-flex>
                                    <v-flex sm5>{{ initialItem[0].valor }}</v-flex>
                                    <v-flex tag="strong" sm6 text-xs-right mr-2 class="green--text"
                                        >Monto de solicitudes pagadas:</v-flex
                                    >
                                    <v-flex sm5>{{ initialItem[2].valor }}</v-flex>
                                    <v-flex tag="strong" sm6 text-xs-right mr-2 class="red--text"
                                        >Monto de solicitudes pendientes:</v-flex
                                    >
                                    <v-flex sm5>{{ initialItem[1].valor }}</v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :loading="loading">OK</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        initialItem: { type: Array, default: null }
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        }
    },

    methods: {
        cancelForm() {
            this.$emit("formCanceled")
        }
    }
}
</script>
